// 專題 推薦 podcast
import PodcastComponent from "../basic/PodcastComponent";

const ProjectPodcast = ({ t, podcasts }) => {
  return (
    <section className="pt-[40px] pb-[64px]">
      {/* 標題 */}
      <p className="text-h5 text-black mb-[18px] text-center">{t("LISTEN")}</p>

      {/* podcast 列表 */}
      <div className="space-y-[30px]">
        {podcasts?.map((podcast, i) => (
          <PodcastComponent
            key={i + "podcast-project" + podcast?.id}
            t={t}
            podcast={podcast}
            location="project"
          />
        ))}
      </div>
    </section>
  );
};

export default ProjectPodcast;
